import moment from 'moment'
const filters={
    //时间戳转日期过滤器
    mtimestamp:function (time,type=1,division='-') {
        if(time==0 || !time){
            return '--'
        }
        let timeStr=""+time;
        if(timeStr.length==10){
            time=time*1000;
        }
        switch (type) {
            //只显示年-月-日
            case 1:
                return moment(time).format(`YYYY${division}MM${division}DD`);
            //只显示年-月-日-时-分
            case 2:
                return moment(time).format(`YYYY${division}MM${division}DD HH:mm`);
            default :
                return moment(time).format(`YYYY${division}MM${division}DD HH:mm:ss`)
        }

    },
};

export default filters



// WEBPACK FOOTER //
// ./src/assets/js/filters.js